import { render, staticRenderFns } from "./area-fields-db.component.vue?vue&type=template&id=bc16ede4"
import script from "./area-fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./area-fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc16ede4')) {
      api.createRecord('bc16ede4', component.options)
    } else {
      api.reload('bc16ede4', component.options)
    }
    module.hot.accept("./area-fields-db.component.vue?vue&type=template&id=bc16ede4", function () {
      api.rerender('bc16ede4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/fields-db/area-fields-db/area-fields-db.component.vue"
export default component.exports